import { render, staticRenderFns } from "./Archeck.vue?vue&type=template&id=181ef51d"
import script from "./Archeck.vue?vue&type=script&lang=js"
export * from "./Archeck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports